import { render, staticRenderFns } from "./metrics-modal-component.vue?vue&type=template&id=9898d5e4&scoped=true"
import script from "./metrics-modal-component.ts?vue&type=script&lang=ts&external"
export * from "./metrics-modal-component.ts?vue&type=script&lang=ts&external"
import style0 from "./metrics-modal-component.scss?vue&type=style&index=0&id=9898d5e4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9898d5e4",
  null
  
)

export default component.exports